module.exports = __webpack_public_path__ + "static/media/free-sign-up__2.61393485.svg";